<template>

    <div class="admin-support-plan-strategies"
         v-if="config.supportPlan">

        <b-btn variant="success" size="sm" class="float-right mb-3"
               @click="addStrategy(true)">
            Add Strategy
        </b-btn>

        <div style="clear:both"></div>

        <draggable class="dragArea"
                   v-model="config.supportPlan.strategies">

            <b-row class="my-2"
                   v-for="(strategy, strategyIndex) in config.supportPlan.strategies">
                <b-col>
                    <b-card no-body class="mb-3">
                        <b-card-header v-b-toggle="`strategy_${strategyIndex}`">

                            <open-icon name="resize-height"
                                       class="drag-handle"></open-icon>
                            <open-icon name="chevron-bottom"
                                       v-if="strategy.visible"></open-icon>
                            <open-icon name="chevron-right"
                                       v-if="!strategy.visible"></open-icon>

                            {{ strategy.title }}

                            <div class="float-right">
                                <b-btn variant="default" size="sm"
                                       @click="deleteStrategy(strategy)">
                                    <open-icon
                                            name="delete"></open-icon>
                                </b-btn>
                            </div>

                        </b-card-header>
                        <b-collapse :id="`strategy_${strategyIndex}`"
                                    v-model="strategy.visible">
                            <b-card-body>

                                <b-form-group label="Strategy Title">
                                    <b-form-input type="text"
                                                  v-model="strategy.title"></b-form-input>
                                </b-form-group>

                                <b-form-group label="Text">
                                    <b-form-textarea rows="10"
                                                     v-model="strategy.text"></b-form-textarea>
                                </b-form-group>
                                <b-form-group label="Annotations">

                                    <draggable class="dragArea"
                                               v-model="strategy.annotations">

                                        <b-row class="mb-2"
                                               v-for="aid in strategy.annotations"
                                               :key="aid">
                                            <b-col>
                                                <b-card no-body class="mb-2">
                                                    <b-card-header class="py-2">
                                                        <open-icon name="resize-height"
                                                                   class="drag-handle"></open-icon>
                                                        {{ getAnnotation(aid).text }}

                                                        <div class="float-right">
                                                            <b-btn variant="default"
                                                                   size="sm"
                                                                   @click="deleteAnnotation(strategy, aid)">
                                                                <open-icon name="delete"></open-icon>
                                                            </b-btn>
                                                        </div>

                                                    </b-card-header>
                                                </b-card>
                                            </b-col>
                                        </b-row>
                                    </draggable>

                                </b-form-group>
                                <b-btn variant="success" size="sm"
                                       class="float-right mb-3"
                                       @click="openAddAnnotationModal(strategy)">
                                    Add Annotation
                                </b-btn>
                                <div style="clear:both"></div>

                                <b-form-group label="Links">
                                    <b-form-textarea v-model="strategy.links"/>
                                </b-form-group>

                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </b-col>
            </b-row>
        </draggable>

        <b-btn variant="success" size="sm" class="float-right mb-3"
               @click="addStrategy(false)">
            Add Strategy
        </b-btn>

        <div class="clearfix"></div>

        <!-- add annotation modal -->

        <b-modal hide-footer
                 id="add-annotation-modal"
                 title="Add an Annotation">

            <b-form-input placeholder="Search" class="mb-4"
                          v-model="annotationSearch">
            </b-form-input>

            <div v-for="annotation in filteredAnnotations">
                <b-btn variant="success" block class="mb-3"
                       @click="addAnnotation(currentStrategy, annotation)">
                    {{ annotation.text }}
                </b-btn>
            </div>

        </b-modal>

    </div>

</template>

<script>

    import Vue from 'vue'
    import draggable from 'vuedraggable'

    export default Vue.extend({
        name: 'AdminSupportPlanStrategies',
        components: {
            draggable
        },
        data() {
            return {
                currentStrategy: null,
                annotationSearch: null
            }
        },
        computed: {
            config() {
                return this.$store.state.config
            },
            filteredAnnotations() {
                return _.filter(this.config.supportPlan.annotations, (a) => {
                    return !this.annotationSearch ||
                        a.text.toLowerCase().indexOf(this.annotationSearch.toLowerCase()) != -1
                })
            }
        },
        methods: {
            addStrategy(atTop) {
                const strategy = this.getNewStrategy()
                const maxStrategy = _.maxBy(this.config.supportPlan.strategies, (s) => s.id)
                strategy.id = maxStrategy ? maxStrategy.id + 1 : 1
                if (atTop) {
                    this.config.supportPlan.strategies.unshift(strategy)
                } else {
                    this.config.supportPlan.strategies.push(strategy)
                }
            },
            deleteStrategy(strategy) {
                if (confirm('Permanently delete this Strategy? This will also remove the Strategy from any Categories and Subjects that include it.')) {
                    this.config.supportPlan.strategies = _.without(this.config.supportPlan.strategies, strategy)

                    // remove from categories/subjects
                    _.each(this.config.supportPlan.statementCategories, (category) => {
                        _.each(category.subjects, (subject) => {
                            subject.strategies = _.without(subject.strategies, strategy.id)
                        })
                    })
                }
            },
            getNewStrategy() {
                return {
                    title: 'New Strategy',
                    // enabled: false,
                    text: '',
                    annotation: '',
                    links: ''
                }
            },
            openAddAnnotationModal(strategy) {
                this.currentStrategy = strategy
                this.$bvModal.show('add-annotation-modal')
            },
            addAnnotation(strategy, annotation) {
                if (!strategy.annotations) {
                    Vue.set(strategy, 'annotations', [])
                }
                strategy.annotations.push(annotation.id)
                this.$bvModal.hide('add-annotation-modal')
            },
            deleteAnnotation(strategy, aid) {
                if (confirm('Remove this Annotation from this Strategy? (This will not delete the Annotation itself)')) {
                    strategy.annotations = _.without(strategy.annotations, aid)
                }
            },
            getAnnotation(id) {
                const annotation = _.find(this.config.supportPlan.annotations, (a) => a.id == id)
                if (annotation) {
                    return annotation
                } else {
                    return {title: 'DELETED ANNOTATION'} // shouldn't happen
                }
            }
        },
    })
</script>
